/**
 * Sidebar navigation items for the CertPerm (Certifications & Permits) module.
 * Provides navigation to dashboard, permits, certifications, and master lists.
 * Navigation items are feature-flag gated.
 */
// @react-compiler-disable
import { Assignment, AssignmentOutlined } from '@mui/icons-material';

import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
// import { useFeatureFlag } from '@/common/presentation/hooks/useFeatureFlag';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { useFeatureFlag } from '@/common/presentation/hooks/useFeatureFlag';

export interface CertPermNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const CertPermNavItems = (): CertPermNavItemsResult => {
  const isPermitsEnabled = useFeatureFlag(FEATURE_FLAGS.CERTPERM_PERMITS);

  const navItems: NavItemType = {
    id: 'certperm',
    title: 'Permits',
    type: 'collapse',
    icon: AssignmentOutlined,
    iconSelected: Assignment,
    url: '/certperm?module=certperm',
    featureFlag: FEATURE_FLAGS.CERTPERM_PERMITS,
    disabled: !isPermitsEnabled,
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/certperm?module=certperm&submodule=dashboard'
      },

      {
        id: 'permits',
        title: 'Permits',
        type: 'item',
        url: '/certperm?module=certperm&submodule=permits'
      },

      {
        id: 'certifications',
        title: 'Certifications',
        type: 'item',
        url: '/certperm?module=certperm&submodule=certifications'
      },

      {
        id: 'requirements',
        title: 'Requirements',
        type: 'item',
        url: '/certperm?module=certperm&submodule=requirements'
      },

      {
        id: 'master-lists',
        title: 'Master Lists',
        type: 'item',
        url: '/certperm?module=certperm&submodule=master-lists'
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default CertPermNavItems;
